import React, { Component } from 'react'

import DocumentCardItem from './DocumentCardItem'
import CardListHeader from '../../common/list/v1/CardListHeader'
import _ from 'lib/lodash'

import './DocumentCardList.css'

class DocumentCardList extends Component {
	render() {
		const { actionHandler, aclAllow, title } = this.props;

		// filter nodes with valid storage information
		const nodes = _.pickBy(this.props.nodes, (node, key) => node.hasOwnProperty('storage'));

		// filter for valid storage entries and reverse nodes to have newest on top
		const renderCards = () => _.map(nodes, (node, key) => (
			<DocumentCardItem node={node} key={key} actionHandler={actionHandler} aclAllow={aclAllow}/>)
		).reverse();

		return (
			<section>
				<CardListHeader
					nodes={nodes}
					actionHandler={actionHandler}
					title={title}
					titleOne="Dokument"
					titleMany="Dokumente"
					aclAllow={aclAllow}
				/>
				<div className="md-list-unstyled image-card-list-items">
					{renderCards()}
				</div>
			</section>
		);
	}
}

export default DocumentCardList;



// WEBPACK FOOTER //
// ./src/components/cards/document/v1/DocumentCardList.jsx